module.exports = __webpack_public_path__ + "img/interacciones.fe0e939e.svg";